import { UPDATE_IS_DEMO_MODE } from '../actions/constants';

export type DashboardState = {
    isDemoMode: boolean;
};

export const initialDashboardState: DashboardState = {
    isDemoMode: false,
};

export default function dashboadReducer(state: DashboardState = initialDashboardState, action: any): DashboardState {
    const newState: DashboardState = { ...state };
    switch (action.type) {
        case UPDATE_IS_DEMO_MODE:
            newState.isDemoMode = action.payload.isDemoMode;
            return newState;

        default:
            return state || initialDashboardState;
    }
}
